import { create } from "zustand";

type ModalType = "info" | "confirm" | null;
type Variant = "default" | "danger";

interface BaseModalState {
  isOpen: boolean;
  type: ModalType;
  title?: string;
  message?: string;
}

interface ConfirmExtras {
  confirmText?: string;
  cancelText?: string;
  variant?: Variant;
  onConfirm?: () => void;
  onCancel?: () => void;
}

interface ModalStore extends BaseModalState, ConfirmExtras {
  openInfo: (params: { title?: string; message: string; onClose?: () => void }) => void;
  openConfirm: (params: {
    title?: string;
    message: string;
    confirmText?: string;
    cancelText?: string;
    variant?: Variant;
    onConfirm?: () => void;
    onCancel?: () => void;
  }) => void;
  close: () => void;
}

export const useModal = create<ModalStore>((set, get) => ({
  isOpen: false,
  type: null,

  openInfo: ({ title, message, onClose }) => {
    const { isOpen, type } = get();
    if (isOpen && type === "info") return;
    set({
      isOpen: true,
      type: "info",
      title,
      message,
      onConfirm: undefined,
      onCancel: onClose,
    });
  },

  openConfirm: ({
    title,
    message,
    confirmText,
    cancelText,
    variant = "default",
    onConfirm,
    onCancel,
  }) => {
    const { isOpen, type } = get();
    if (isOpen && type === "confirm") return;
    set({
      isOpen: true,
      type: "confirm",
      title,
      message,
      confirmText: confirmText ?? "확인",
      cancelText: cancelText ?? "취소",
      variant,
      onConfirm,
      onCancel,
    });
  },

  close: () => {
    set({
      isOpen: false,
      type: null,
      title: undefined,
      message: undefined,
      confirmText: undefined,
      cancelText: undefined,
      variant: "default",
      onConfirm: undefined,
      onCancel: undefined,
    });
  },
}));
